import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  showSideBar = true;
  showSidebarOnResponsiveView = false;
  showUserStatusPanel = false;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSideBarToggle = new EventEmitter<boolean>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onHeaderBarToggle = new EventEmitter<boolean>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUserStatusToggle = new EventEmitter<boolean>();

  constructor() {
  }

  toggleSideBar() {
    this.showSideBar = !this.showSideBar;
    this.onSideBarToggle.emit(this.showSideBar);
  }

  openSideBar() {
    this.showSidebarOnResponsiveView = true;
    this.onHeaderBarToggle.emit(this.showSidebarOnResponsiveView);
  }

  closeSideBar() {
    this.showSidebarOnResponsiveView = false;
    this.onHeaderBarToggle.emit(this.showSidebarOnResponsiveView);
  }

  toggleUserStatus() {
    this.showUserStatusPanel = !this.showUserStatusPanel;
    this.onUserStatusToggle.emit(this.showUserStatusPanel);
  }
  hideUserStatus() {
    this.showUserStatusPanel = false;
    this.onUserStatusToggle.emit(this.showUserStatusPanel);
  }

  getUserStatusStatus() {
    return this.showUserStatusPanel;
  }

}
